export default {
	DEV: 'dev',
	AT: 'at',
	LOCAL: 'local',
	PROD: 'prod',
};
